import "./buttons.scss";

import { ReactComponent as TrashIcon } from "../icons/trashCanIcon.svg";

export const TrashButton = (props: {
  onClick: () => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button trash"
      onClick={props.onClick}
    >
      <TrashIcon />
    </button>
  );
};
